const Success: string = "I0000"
const AccountLimit: string = "I0002"
const AccountDuplication: string = "I0003"
const SessionDisconnected: string = "I1001"
const SessionTimeOut: string = "I1002"
const AccountLock: string = "I1003"
const AuthFail: string = "I1004"
const SystemError: string = "E9999"
const SessionErrorTitle: string = "セッションエラー"
const SystemErrorTitle: string = "システムエラー"
const SessionDuplicateMsg: string = "同一IDでのログインが行われました。再度ログインして画面操作をお願いします。"
const SessionTimeoutMsg: string = "一定時間操作が行われなかったため、ログアウトしました。"
const SystemErrorMsg: string = "予期せぬエラーが発生しました。"
const DuplicationMsg: string = "入力されたメールアドレスが重複しています<br/>他のメールアドレスを入力してください"

export {
    Success, AccountLimit, SessionDisconnected, SessionTimeOut, AccountLock, AuthFail, SystemError, SessionErrorTitle, SystemErrorTitle, SessionDuplicateMsg, SessionTimeoutMsg, SystemErrorMsg, AccountDuplication, DuplicationMsg
};